"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var toggleList_1 = __importDefault(require("../commands/toggleList"));

var Node_1 = __importDefault(require("./Node"));

var OrderedList =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(OrderedList, _Node_1$default);

  function OrderedList() {
    _classCallCheck(this, OrderedList);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrderedList).apply(this, arguments));
  }

  _createClass(OrderedList, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return toggleList_1.default(type, schema.nodes.list_item);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        "Shift-Ctrl-9": toggleList_1.default(type, schema.nodes.list_item)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [prosemirror_inputrules_1.wrappingInputRule(/^(\d+)\.\s$/, type, function (match) {
        return {
          order: +match[1]
        };
      }, function (match, node) {
        return node.childCount + node.attrs.order === +match[1];
      })];
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.write("\n");
      var start = node.attrs.order !== undefined ? node.attrs.order : 1;
      var maxW = "".concat(start + node.childCount - 1).length;
      var space = state.repeat(" ", maxW + 2);
      state.renderList(node, space, function (i) {
        var nStr = "".concat(start + i);
        return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
      });
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "ordered_list",
        getAttrs: function getAttrs(tok) {
          return {
            order: parseInt(tok.attrGet("start") || "1", 10)
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "ordered_list";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          order: {
            default: 1
          }
        },
        content: "list_item+",
        group: "block",
        parseDOM: [{
          tag: "ol",
          getAttrs: function getAttrs(dom) {
            return {
              order: dom.hasAttribute("start") ? parseInt(dom.getAttribute("start") || "1", 10) : 1
            };
          }
        }],
        toDOM: function toDOM(node) {
          return node.attrs.order === 1 ? ["ol", 0] : ["ol", {
            start: node.attrs.order
          }, 0];
        }
      };
    }
  }]);

  return OrderedList;
}(Node_1.default);

exports.default = OrderedList;